import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { TOAST_VARIANTS } from 'src/constants/toast.constants'
import { getPlanName } from 'src/lib/utilities'
import AutoExtractSuccessMessage from 'src/pages/CreatePlan/AutoExtractSuccessMessage'
import { RootState } from 'src/redux/stores/store'

import { showToast } from '../toastNotification/toastNotification'

// Stable fallback so the effect deps below don't change on every render
// while divisions/regions are still loading — an inline `|| {}` is a new
// object each render and can re-fire the toast.
const EMPTY_LOOKUP = {}

export const AutoExtractNotificationListener: React.FC = () => {
  const {
    error,
    fileUploadedBy,
    planIds,
    successfullyUpdatedDraftPlan,
    successfulPlans,
  } = useSelector((state: RootState) => state.createPlan.autoExtractedData)

  const regions =
    useSelector(
      (state: RootState) => state.divisionsAndRegions.data?.regions
    ) || EMPTY_LOOKUP

  const divisions =
    useSelector(
      (state: RootState) => state.divisionsAndRegions.data?.divisions
    ) || EMPTY_LOOKUP

  const { userInfo } = useSelector((state: RootState) => state.Auth)

  useEffect(() => {
    if (fileUploadedBy === userInfo?.email && successfulPlans?.length) {
      const planNames: string[] = []
      for (const plan of successfulPlans) {
        const planName = getPlanName(
          {
            communityId: plan.communityId,
            division: plan.divisionName,
            plan: plan.plan,
            planCategory: plan.planCategory,
            planElevation: plan.planElevation,
            region: plan.regionName,
          },
          regions,
          divisions
        )
        planNames.push(planName)
      }

      if (planIds?.length && successfullyUpdatedDraftPlan) {
        showToast({
          message: (
            <AutoExtractSuccessMessage
              planIds={planIds}
              planNames={planNames}
            />
          ),
          type: TOAST_VARIANTS.SUCCESS,
        })
      } else if (!successfullyUpdatedDraftPlan && error) {
        showToast({
          message: 'The file couldn’t be processed. Please try again later.',
          type: TOAST_VARIANTS.ERROR,
        })
      }
    }
  }, [
    planIds,
    successfullyUpdatedDraftPlan,
    successfulPlans,
    regions,
    divisions,
    fileUploadedBy,
    userInfo?.email,
  ])

  return null
}
